import React from 'react';

import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  column: {
    '&:first-child': {
      minWidth: '200px',
      maxWidth: '200px',
      position: 'sticky',
      left: '0px',
      top: '0px',
    },
    backgroundColor: '#222222',
    borderBottom: '1px solid rgb(236, 236, 236)',
    borderRight: '1px solid rgb(236, 236, 236)',
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: 'bolder',
    minWidth: '100px',
    maxWidth: '100px',
    padding: '0.7rem 0',
    textAlign: 'center',
  },
});

interface ListHeadersProps {
  headers: string[];
}

const ListHeaders = ({ headers }: ListHeadersProps) => {
  const classes = useStyles();
  return (
    <Box display="flex" position="sticky" zIndex={2} top={0}>
      {headers.map((header) => (
        <Box key={header} className={classes.column}>
          {header}
        </Box>
      ))}
    </Box>
  );
};

export default ListHeaders;
